import { apiDomain, basename } from '../setting';

const feWriteLog = async (msg) => {
    const response = await fetch(`${apiDomain}/${basename}/api/general/feWriteLog`, {
        method: 'POST',
        headers: {
            // 'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
            "log": msg
        })
    });
}

export default feWriteLog;